import React, { useState, useEffect, useRef } from 'react';
import * as d3 from 'd3';

const RotatingMap = ({ geoJson, size }) => {
  const [rotation, setRotation] = useState(0);
  const requestRef = useRef();

  useEffect(() => {
    const animate = () => {
      setRotation((prev) => prev + 0.2);
      requestRef.current = requestAnimationFrame(animate);
    };
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
  }, []);

  const projection = d3.geoOrthographic()
    .fitSize([size, size], geoJson)
    .rotate([rotation]);

  const geoGenerator = d3.geoPath().projection(projection);
  const pathString = geoGenerator(geoJson);

  return (
    <svg width={size} height={size}>
      <defs>
        {/* Blue dot pattern for land */}
        <pattern id="digitalDots" patternUnits="userSpaceOnUse" width="6" height="6">
          <circle cx="3" cy="3" r="2" fill="#0075d3" />
        </pattern>
      </defs>

        <radialGradient id="sphereGradient" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stop-color="rgb(17, 0, 255)" />   
            <stop offset="100%" stop-color="rgb(1, 0, 44)" /> 
        </radialGradient>


      {/* Sphere background */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={size / 2}
        fill="url(#sphereGradient)"
      />

      {/* Land texture using dot pattern */}
      <path
        d={pathString}
        fill="url(#digitalDots)"
        stroke="none"
      />
    </svg>
  );
};

export default RotatingMap;
